import { useAuthStore } from './core/stores/authStore'
import { useTranslation } from './core/hooks/useTranslation'
import { useEffect } from 'react'
import { Toaster } from 'react-hot-toast'
import AppRoutes from './routes/AppRoutes'

function App() {
  const { initializeAuth } = useAuthStore()
  const { direction, fontClass } = useTranslation()

  useEffect(() => {
    initializeAuth()
  }, [initializeAuth])

  useEffect(() => {
    // Update document direction and font
    document.documentElement.dir = direction
    document.body.className = `${fontClass} min-h-screen`
  }, [direction, fontClass])

  return (
    <>
      <div className="min-h-screen">
        <AppRoutes />
      </div>

      {/* Toast Notifications */}
      <Toaster
        position={direction === 'rtl' ? 'top-left' : 'top-right'}
        toastOptions={{
          duration: 4000,
          style: {
            background: '#fff',
            color: '#374151',
            borderRadius: '12px',
            border: '1px solid #e5e7eb',
            boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
            fontFamily: fontClass.includes('arabic') ? 'Almarai, Tajawal, Cairo, sans-serif' : 'Poppins, Inter, sans-serif',
          },
          success: {
            iconTheme: {
              primary: '#10b981',
              secondary: '#fff',
            },
          },
          error: {
            iconTheme: {
              primary: '#ef4444',
              secondary: '#fff',
            },
          },
        }}
      />
    </>
  )
}

export default App